import Vue from 'vue'
import VueRouter from 'vue-router';


// Components
const RegistrationConnections        = () => import('./components/Connections');
const RegistrationSMSMessage         = () => import('./components/SMSMessageConnection');
const GoogleHangoutsChatStep2        = () => import('./components/GoogleHangoutsChatStep2');
const RegistrationCreateReminder     = () => import('./components/CreateReminder');
const RegistrationAccountDetails     = () => import('./components/AccountDetails');
const AccountClosed                  = () => import('./components/AccountClosed');

const TermsOfService                 = () => import('./components/TermsOfService');
const PrivacyPolicy                  = () => import('./components/PrivacyPolicy');
const Error404                       = () => import('./components/Error404');


// Export routes
Vue.use(VueRouter);

export default new VueRouter({
    mode: 'history',
    base: __dirname,
    routes: [

        // Application
        { name: 'dashboard',                    path: '/app' },
        { name: 'connections',                  path: '/app/connections' },
        { name: 'reminders',                    path: '/app/reminders' },
        { name: 'closed',                       path: '/app/closed',            component: AccountClosed },
        { name: 'setTimezone',                  path: '/sign-up/timezone' },

        // Step 1 - Connections
        { name: 'registrationConnections',      path: '/sign-up',               component: RegistrationConnections },
        { name: 'registrationSMSMessage',       path: '/sign-up/sms',           component: RegistrationSMSMessage },
        { name: 'googleHangoutsChatStep2',      path: '/sign-up/add-google-hangouts-chat', component: GoogleHangoutsChatStep2 },

        // Step 2 - Reminder
        { name: 'registrationCreateReminder',   path: '/sign-up/reminder',      component: RegistrationCreateReminder },

        // Step 3 - Plan
        { name: 'registrationAccountDetails',   path: '/sign-up/account',       component: RegistrationAccountDetails },

        // Other
        { name: 'termsOfService',               path: '/terms-of-service',      component: TermsOfService },
        { name: 'privacyPolicy',                path: '/privacy-policy',        component: PrivacyPolicy },

        // Errors
        { name: '404',                          path: '/404',                   component: Error404 },
        { name: 'CatchAllError',                path: '/*',                     component: Error404 },

    ],
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});
